export const removeEmTags = (text: string): string =>
    text.replace(/<\/?em\b[^>]*>/gi, '');
